import { render } from "./TailwindTest.vue?vue&type=template&id=71bed47f"
import script from "./TailwindTest.vue?vue&type=script&lang=js"
export * from "./TailwindTest.vue?vue&type=script&lang=js"
script.render = render

export default script